// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { apiEndpoints } from "../../config";
import MediaLibrary from "../../partials/mediaLibrary";
import { get_csrf_token } from "../../core/auth";

import { Button } from "@mui/material";

import PostEdit from "../../partials/posts/postEdit";

export default function NewsEdit() {
  const [post, setPost] = useState(null);
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [csrf_token, setCsrfToken] = useState(null);
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    get_csrf_token().then((response) => setCsrfToken(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   const extraFields = useMemo(() => ({}), []);

  return (
    <PostEdit
      apiEndpoint={apiEndpoints.news}
      screenClassName={"news"}
      categoryTitle={"News category"}
      categoryName={"field_news_category"}
      targetVid={"news_categories"}
      returnRoute={"/news-creator"}
      backBtnText={"News Library"}
      previewRoute={"/news/preview"}
      logCustomEventType={"News"}
      featuredImageEnabled={true}
      editorProps={{ imageBlockEnabled: true }}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
      imageBlockEnabled={true}
    ></PostEdit>
  );
}
